<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>{{ heading }}</h2>
        <a href="#" class="btn btn-primary"
          style="position: absolute;right: 0;top: 0;"
          @click="openCreateModal"
        >
          <i class="fa fa-plus"></i> Create
        </a>
      </div>
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center"
          v-for="product in products"
        >
          {{ product.name }}
          <div>
            <button type="button" class="btn btn-warning btn-sm"
              @click="openEditModal(product)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn btn-secondary btn-sm"
              @click="deleteProduct(product)"
            >
              <i class="fa fa-trash-alt"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <cu-modal :modalContent="modalContent" v-if="modalContent"
      @productUpdated="productUpdated"
      @productStored="productStored"
    />
  </div>
</template>

<script>
  import CuModal from './CuModal'

  export default {
    props: ['heading', 'initProducts', 'productType', 'baseUrl'],
    components: { CuModal },
    data() {
      return {
        products: this.initProducts,
        modalContent: null,
      }
    },
    methods: {
      deleteProduct(product) {
        if (window.confirm(`Do you really want to delete the product ${product.name}?`)) {
          window.axios.delete(`/${this.baseUrl}/${product.id}`).then(({data}) => {
            window.notification.success(`${product.name} has been deleted`, 'Success!')
            const index = this.products.findIndex(eProduct => eProduct.id === product.id)
            this.products.splice(index, 1)
          })
        }
      },
      openEditModal(product) {
        this.modalContent = {
          title: `Edit ${product.name}`,
          formClassFields: product,
          submitMethod: 'put',
          submitUrl: `/${this.baseUrl}/${product.id}`,
          successEvent: 'productUpdated',
          submitText: 'Save',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      openCreateModal() {
        this.modalContent = {
          title: `Create ${this.productType} Product`,
          formClassFields: {
            name: '',
          },
          submitMethod: 'post',
          submitUrl: `/${this.baseUrl}`,
          successEvent: 'productStored',
          submitText: 'Create',
        }
        this.$nextTick(() => $('#cuModal').modal('show'))
      },
      productUpdated(uProduct) {
        window.notification.success(`${uProduct.name} has been updated`, 'Success!')
        const product = this.products.find(eProduct => eProduct.id === uProduct.id)
        product.name = uProduct.name
        $('#cuModal').modal('hide')
      },
      productStored(product) {
        window.notification.success(`${product.name} has been created`, 'Success!')
        this.products.push(product)
        $('#cuModal').modal('hide')
      },
    },
    mounted() {
      $(document).on('hide.bs.modal', '#cuModal', () => this.modalContent = null)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/products/ProductsIndex.vue